import { render, staticRenderFns } from "./DictationSection.vue?vue&type=template&id=f28bddfe&scoped=true&"
import script from "./DictationSection.vue?vue&type=script&lang=js&"
export * from "./DictationSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f28bddfe",
  null
  
)

export default component.exports